import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { store } from 'redux/store';
import {
  selectMeteorologyFieldsModelPerformanceAnalysisType,
  setFilter,
} from 'redux/reducers/meteorologyFieldsModelPerformanceReducer';

export default function useAnalysisType() {
  const analysisType = useSelector(selectMeteorologyFieldsModelPerformanceAnalysisType);

  const setAnalysisType = useCallback((value: string | undefined) => {
    store.dispatch(setFilter({ analysisType: value }));
  }, []);

  return {
    analysisType,
    setAnalysisType,
  };
}
